import React, { useEffect, useState } from "react";
import "../../style/index.css";
import { message } from "antd";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useHistory } from "react-router-dom";
import { Row, Col, Input, Button } from "antd";
import DataTable from "../../../../Components/DataTable";
import GeneratePH10Modal from "../GenerateChallanModal/GenerateChallanModal";
import * as taxCollectionActions from "../../../../actionCreators/TaxCollection";
import { addEllipsis } from "../../../../utils";

const TaxProperties = ({
  handleSelectedData,
  taxPropertiesList,
  getTaxPropertiesList,
  generateChallanAction,
  generateChallan,
  user,
}) => {
  const history = useHistory();
  const [row, setRow] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pin, setPin] = useState("");
  const [searchedPin, setSearchedPin] = useState("");
  const [data, setData] = React.useState([]);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [isInspector, setIsInspector] = React.useState(true);
  const [circles, setCircles] = useState([]);
  const [pagination, setPagination] = React.useState({
    page: 0,
    pageSize: 10,
  });

  React.useEffect(() => {
    getTaxPropertiesList({ page: 0, pageSize: 10 });
    if (user) {
      let userCircles = user?.currentUser?.data?.circles;
      let temp = [];
      if (userCircles) {
        userCircles.map((data) => {
          let circle = {};
          circle["text"] = data?.name;
          circle["value"] = data?.id;
          temp.push(circle);
        });
        setCircles([...temp]);
      }
    }
  }, []);
  useEffect(() => {
    if (!generateChallan.loading) {
      getTaxPropertiesList({
        page: currentPage - 1,
        pageSize: pageSize,
        pin: searchedPin,
      });
      setShowModal(false);
      setRow(null);
    }
  }, [generateChallan.loading]);
  React.useEffect(() => {
    if (user) {
      setIsInspector(
        user?.currentUser?.data?.user_roles.findIndex((e) => e.role_id == 1) >=
          0
      );
    }
  }, [user]);
  React.useEffect(() => {
    if (taxPropertiesList?.data) {
      setPagination(taxPropertiesList.pagination);
      setLoading(taxPropertiesList.loading);
      setData(taxPropertiesList.data);
    }
  }, [taxPropertiesList]);

  const handleTablePageChange = (tableChangeData, filters) => {
    const { current, pageSize } = tableChangeData;
    setCurrentPage(current);
    setPageSize(pageSize);
    getTaxPropertiesList({
      page: current - 1,
      pageSize: pageSize,
      pin: searchedPin,
    });
  };
  const onSearched = () => {
    setSearchedPin(pin);
    getTaxPropertiesList({
      page: 0,
      pageSize: 10,
      pin: pin,
    });
  };

  const tableColumns = [
    {
      title: "PIN",
      dataIndex: ["pin"],
      render: (pin) => (pin ? pin : "---"),
    },
    {
      title: "Owner Name",
      dataIndex: ["property_owners"],
      render: (property_owners) => {
        return addEllipsis(property_owners.map((e) => e.name).join(","));
      },
    },
    {
      title: "Circle",
      dataIndex: ["valuation_datum"],
      filters: circles,
      onFilter: (data, row) => {
        if (data === row?.valuation_datum?.circle_id) {
          return true;
        } else {
          return false;
        }
      },
      render: (valuation_datum) =>
        valuation_datum.circle ? valuation_datum.circle.name : "---",
    },
    {
      title: "Highway",
      dataIndex: ["valuation_datum"],
      render: (valuation_datum) =>
        valuation_datum.highway ? valuation_datum.highway.name : "---",
    },
    {
      title: "Address",
      dataIndex: ["address"],
      render: (address) => (address ? address : "---"),
    },
    {
      title: "ATV",
      dataIndex: "taxes",
      render: (taxes) =>
        taxes.length > 0
          ? "RS. " + taxes[0]?.annual_taxable_value?.toLocaleString()
          : "---",
    },
    {
      title: "Total Tax (5% of ATV)",
      dataIndex: "taxes",
      render: (taxes) =>
        taxes.length > 0
          ? "RS. " + taxes[0].annual_tax?.toLocaleString()
          : "---",
    },
    {
      title: "Total Payable ",
      dataIndex: "taxes",
      render: (taxes) =>
        taxes.length > 0
          ? "RS. " +
            (taxes[0].ph10s.length > 0
              ? taxes[0].ph10s[0].total_tax
              : taxes[0].annual_tax
            ).toLocaleString()
          : 0,
    },

    {
      title: "Actions",
      dataIndex: "status",
      render: (status, record) => {
        return (
          <div
            style={{
              cursor: "pointer",
              color: "#2196F3",
              textDecoration: "underLine",
            }}
            onClick={() => onGenratePh10Cilck(record)}
          >
            Generate Challan
          </div>
        );
      },
    },
  ];
  const onTableRowClick = (data) => {
    // taxCollectionActions.resetTaxCollection();
    history.push("/tax-collection/detail-view/" + data.id);
  };
  const onGenratePh10Cilck = (data) => {
    setShowModal(true);
    setRow(data);
  };
  const genratePh10 = async (values) => {
    let property_data = {
      address: row?.address,
      circle: row?.valuation_datum?.circle,
      highway: row.valuation_datum?.highway,
      property_owners: row?.property_owners,
      occupiers: row?.occupiers,
    };
    let ph10Details = {
      annual_tax: row?.taxes[0]?.annual_tax,
      arrears: values?.arrears ? values.arrears : 0,
      surcharge: values?.surcharge ? values.surcharge : 0,
      type: "Combined",
      property_id: row?.id,
      taxes_id: row?.taxes[0]?.id,
      property_data,
    };
    await generateChallanAction(ph10Details);
  };

  return (
    <>
      <Row>
        <Col span={22} style={{ marginRight: "1%" }}>
          <Input
            placeholder="Search PIN"
            value={pin}
            onPressEnter={onSearched}
            onChange={(e) => {
              setPin(e.target.value);
            }}
          />
        </Col>
        <Col span={1}>
          <Button type="primary" onClick={onSearched}>
            Search
          </Button>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <DataTable
            rowClassName="table-row-cursor-pointer"
            columns={tableColumns}
            pagination={pagination}
            loading={loading}
            data={data}
            selection={isInspector ? false : true}
            handleTableValuesChange={handleTablePageChange}
            onRowClick={onTableRowClick}
            scroll={{ x: "max-content" }}
          />
        </Col>
      </Row>
      <GeneratePH10Modal
        visible={showModal}
        initialPayableValue={row?.taxes[0]?.annual_tax}
        onModalSubmit={genratePh10}
        loading={generateChallan?.loading}
        onModalCancel={() => {
          setShowModal(false);
        }}
        initialArrearsValue={row?.taxes[0]?.arrears}
      />
    </>
  );
};

const mapStateToProps = ({
  taxCollection: { taxPropertiesList, generateChallan },
  user: user,
}) => ({ user, taxPropertiesList, generateChallan });

const mapDispatchToProps = (dispatch) => ({
  getTaxPropertiesList: bindActionCreators(
    taxCollectionActions.getTaxPropertiesList,
    dispatch
  ),
  generateChallanAction: bindActionCreators(
    taxCollectionActions.generateChallan,
    dispatch
  ),
});

TaxProperties.propTypes = {
  getTaxPropertiesList: PropTypes.func.isRequired,
  generateChallan: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(TaxProperties);
